import { render, staticRenderFns } from "./ArrowIn.vue?vue&type=template&id=3a732657&"
import script from "./ArrowIn.vue?vue&type=script&lang=js&"
export * from "./ArrowIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports